import { object, string } from "yup";

export const OrderRejectReasonTypeSchema = object({
  name: string().required("Задолжително"),
  description: string(),
});
